import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Box,
  Paper
} from '@mui/material';
import axios from 'axios';
import baseURL from '../../baseURL';
import { useNavigate, useParams } from 'react-router-dom';

const CreateGovernmentInterestPage = () => {
  const [formData, setFormData] = useState({
    interestRateNumeric: '',
    interestRateWords: '',
    durationNumeric: '',
    durationWords: ''
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode) {
      const fetchInterest = async () => {
        try {
          const token = localStorage.getItem('token');
          const response = await axios.get(`${baseURL}/government-interests/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setFormData(response.data.data);
        } catch (err) {
          setError('Failed to fetch government interest');
        }
      };
      fetchInterest();
    }
  }, [id, isEditMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const url = isEditMode 
        ? `${baseURL}/government-interests/${id}` 
        : `${baseURL}/government-interests`;
      
      const method = isEditMode ? axios.put : axios.post;
      
      await method(url, formData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      navigate('/admin/government-interests');
    } catch (err) {
      setError('Failed to save government interest');
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" gutterBottom>
            {isEditMode ? 'Edit' : 'Create'} Government Interest
          </Typography>
          
          {error && <Typography color="error">{error}</Typography>}
          
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                label="Interest Rate (Numeric)"
                name="interestRateNumeric"
                type="number"
                value={formData.interestRateNumeric}
                onChange={handleChange}
                required
                fullWidth
                inputProps={{ min: 0, max: 100, step: 0.1 }}
              />
              <TextField
                label="Interest Rate (Words)"
                name="interestRateWords"
                value={formData.interestRateWords}
                onChange={handleChange}
                required
                fullWidth
              />
              <TextField
                label="Duration (Numeric)"
                name="durationNumeric"
                type="number"
                value={formData.durationNumeric}
                onChange={handleChange}
                required
                fullWidth
                inputProps={{ min: 0 }}
              />
              <TextField
                label="Duration (Words)"
                name="durationWords"
                value={formData.durationWords}
                onChange={handleChange}
                required
                fullWidth
              />
              <Button 
                type="submit" 
                variant="contained" 
                color="primary"
              >
                {isEditMode ? 'Update' : 'Create'} Government Interest
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default CreateGovernmentInterestPage;